import React from 'react';
import { isRTL } from 'config/localisation';
import FEATURES_CONFIG from 'config/features';
import { RRWrapper } from './RRCarousel.style';
import { PLACEMENTS, VARIANT } from '../../constants/carousel.constants';

const placementArray = PLACEMENTS.split('|');
const [topPlacement, bottomPlacement] = placementArray;

const RRCarousal = ({
  carousels,
  productIds,
  variant,
}: {
  carousels: any[];
  productIds: string;
  variant: string;
}) => {
  const isRelevanceCarouselEnabled = FEATURES_CONFIG.settings.enableRelevanceWidgetOnCart;

  let marginTop;
  let placement;

  if (variant === VARIANT.TOP) {
    marginTop = 0;
    placement = topPlacement;
  } else {
    marginTop = 25;
    placement = bottomPlacement;
  }

  return isRelevanceCarouselEnabled && productIds && carousels[0] !== null ? (
    <RRWrapper marginBottom={24} marginTop={marginTop} isRTL={isRTL()}>
      {carousels[0][placement]}
    </RRWrapper>
  ) : (
    <></>
  );
};

export default RRCarousal;
